import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

import Login from "../auth/Login";
import Dashboard from "../auth/Dashboard";
import Footer from "./Footer";
import "../css/App.css";

const Home = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      setIsLoggedIn(true); // 토큰이 있으면 로그인 상태로 설정
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("username");
    setIsLoggedIn(false); // 로그아웃 시 로그인 상태 변경
    navigate("/"); // 홈으로 리다이렉트
  };

  const handleLogin = () => {
    setIsLoggedIn(true); // 로그인 성공 시 호출됨
  };

  const 게시판링크 = {
    "자유 게시판": "/board",
    "Q&A 게시판": "/QnAboard",
    "버스 중고 게시판": "/sellboard",
    "기사 구직 게시판": "/driverboard",
  };

  return (
    <div className="App">
      <main className="content">
        <div className="content-center">
          {/* 좌측 게시판 섹션 */}
          <div className="content-left">
            <div className="content-Flex">
              <Board
                title="자유 게시판"
                posts={["포스트 1", "포스트 2"]}
                게시판링크={게시판링크}
              />
              <Board
                title="Q&A 게시판"
                posts={["질문 1", "질문 2"]}
                게시판링크={게시판링크}
              />
            </div>
            <div className="content-Flex">
              <Board
                title="버스 중고 게시판"
                posts={["판매 1", "판매 2"]}
                게시판링크={게시판링크}
              />
              <Board
                title="기사 구직 게시판"
                posts={[]}
                게시판링크={게시판링크}
              />
            </div>
          </div>

          {/* 우측 로그인 및 대시보드 섹션 */}
          <div className="content-right">
            {!isLoggedIn ? (
              // 로그인 폼을 보여줌
              <Login onLogin={handleLogin} />
            ) : (
              // 로그인 상태일 때 대시보드를 보여줌
              <Dashboard onLogout={handleLogout} />
            )}
            <Link to="/Driverrule">교육 링크</Link>
          </div>
        </div>
      </main>

      <footer>
        <Footer />
      </footer>
    </div>
  );
};

// 게시판 컴포넌트
function Board({ title, posts, 게시판링크 }) {
  return (
    <div className="board">
      <h2>
        <Link to={게시판링크[title]}>{title}</Link>
      </h2>
      <ul>
        {posts.length > 0 ? (
          posts.map((post, index) => (
            <li key={index}>
              <Link to={`/board/${index}`}>{post}</Link>
            </li>
          ))
        ) : (
          <li>게시물이 없습니다.</li>
        )}
      </ul>
    </div>
  );
}

export default Home;
